<template>
    <div>
        <section class="user_profile inner_pages">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-sm-3">
                        <div class="profile_nav">
                            <ul>
                                <li>
                                    <a href="/mi_perfil">Mi perfil</a>
                                </li>
                                <li>
                                    <a href="/mis_retomas">Mis Retomas</a>
                                </li>
                                <li class="active">
                                    <a href="/reportar_vehiculo"
                                        >Reportar Vehículo</a
                                    >
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-8">
                        <div class="profile_wrap">
                            <h5 class="uppercase underline">
                                Reportar Nuevo Vehículo
                            </h5>
                            <form action="#" method="get">
                                <div class="form-group">
                                    <label class="control-label"
                                        >Marca</label
                                    >
                                    <div class="select">
                                        <select class="form-control white_bg">
                                            <option>Select Brand</option>
                                            <option>Brand 1</option>
                                            <option>Brand 2</option>
                                            <option>Brand 3</option>
                                            <option>Brand 4</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">Modelo</label>
                                    <div class="select">
                                        <select class="form-control white_bg">
                                            <option>Select Model</option>
                                            <option>Model 2</option>
                                            <option>Model 3</option>
                                            <option>Model 4</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label">Linea</label>
                                    <div class="select">
                                        <select class="form-control white_bg">
                                            <option>Select Model</option>
                                            <option>Model 2</option>
                                            <option>Model 3</option>
                                            <option>Model 4</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label"
                                        >Version</label
                                    >
                                    <div class="select">
                                        <select class="form-control white_bg">
                                            <option>Version</option>
                                            <option>Version 1.1</option>
                                            <option>Version 1.2</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label"
                                        >Kilometraje</label
                                    >
                                    <input
                                        class="form-control white_bg"
                                        id="km"
                                        type="text"
                                    />
                                </div>
                                <div class="form-group">
                                    <label class="control-label"
                                        >Color</label
                                    >
                                    <input
                                        class="form-control white_bg"
                                        id="color"
                                        type="text"
                                    />
                                </div>
                                <div class="form-group">
                                    <label class="control-label"
                                        >Precio de oferta</label
                                    >
                                    <input
                                        class="form-control white_bg"
                                        id="Price"
                                        type="text"
                                    />
                                </div>
                                <div class="form-group">
                                    <label class="control-label"
                                        >Cargar Fotos</label
                                    >
                                    <div class="vehicle_images">
                                        <div>
                                            <img
                                                src="assets/images/900x560.jpg"
                                                alt="image"
                                            />
                                        </div>
                                        <div>
                                            <img
                                                src="assets/images/900x560.jpg"
                                                alt="image"
                                            />
                                        </div>
                                        <div class="upload_more_img">
                                            <input name="upload" type="file" />
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <button type="submit" class="btn">
                                        Reportar
                                        <span class="angle_arrow"
                                            ><i
                                                class="fa fa-angle-right"
                                                aria-hidden="true"
                                            ></i
                                        ></span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
